import { HighlightStyle, syntaxHighlighting } from '@codemirror/language';
import { tags } from '@lezer/highlight';

import { colors } from 'common';

const nodeNameHighlightStyle = HighlightStyle.define([
  {
    tag: tags.keyword,
    color: colors.extended.yellow[35],
  },
  {
    tag: tags.variableName,
    color: colors.extended.green[30],
  },
  {
    tag: tags.propertyName,
    color: colors.extended.blue[60],
  },
  {
    tag: tags.number,
    color: colors.extended.blue[70],
  },
  {
    tag: tags.attributeName,
    color: colors.extended.blue[40],
  },
  {
    tag: tags.brace,
    color: colors.extended.blue[70],
  },
  {
    tag: tags.lineComment,
    color: colors.extended.green[40],
  },
  {
    tag: tags.blockComment,
    color: colors.extended.green[40],
  },
  {
    tag: tags.invalid,
    color: colors.extended.red[50],
    backgroundImage:
      'url(data:image/gif;base64,R0lGODlhBgADAIABAP8AAP///yH5BAEKAAEALAAAAAAGAAMAAAIGRB5mibAFADs=)',
    backgroundRepeat: 'repeat-x',
    backgroundPosition: 'bottom',
  },
]);
export const nodeNameHighlightTheme = syntaxHighlighting(nodeNameHighlightStyle);
